import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Camera, ArrowRight, Loader2 } from 'lucide-react';
import CorporateHeader from './CorporateHeader';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const AIPhotoshootsThankYouPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id') || '';
  const packageId = searchParams.get('package') || '';
  const [confirming, setConfirming] = useState(true);
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (!sessionId) { setConfirming(false); return; }
    const confirmPayment = async () => {
      try {
        const res = await fetch(`${API_URL}/api/ai-service/confirm-payment`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId, origin_url: window.location.origin }),
        });
        const data = await res.json();
        setConfirmed(data.confirmed === true);
      } catch (err) {
        console.error(err);
      } finally {
        setConfirming(false);
      }
    };
    confirmPayment();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-black">
      <CorporateHeader />
      <div className="pt-28 pb-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-2xl text-center">
          <div className="bg-gray-900/50 border border-amber-800/30 rounded-2xl p-8 sm:p-12">
            {confirming ? (
              <div className="py-8">
                <Loader2 className="w-12 h-12 text-amber-400 mx-auto mb-4 animate-spin" />
                <p className="text-gray-400">Confirming your payment...</p>
              </div>
            ) : (
              <>
                <div className="w-20 h-20 bg-green-600/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <CheckCircle className="w-10 h-10 text-green-400" />
                </div>
                <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4" data-testid="thankyou-title">
                  Payment Confirmed. Your transformation starts now.
                </h1>
                <p className="text-gray-400 leading-relaxed mb-8">
                  To begin your photoshoot, please complete your intake form and upload your photos.
                </p>
                <Button
                  onClick={() => navigate(`/photoshoot-intake?session_id=${sessionId}&package=${packageId}`)}
                  className="bg-gradient-to-r from-amber-600 to-yellow-600 hover:from-amber-700 hover:to-yellow-700 text-black font-bold px-10 py-4 text-lg rounded-full"
                  data-testid="goto-intake-btn"
                >
                  <Camera className="w-5 h-5 mr-2" />
                  Complete Your Intake
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </>
            )}
          </div>
          <div className="mt-8 text-center">
            <p className="text-amber-400/80 text-sm font-semibold tracking-wider">eBlackBook AI Luxury Photoshoots</p>
            <p className="text-gray-600 text-xs mt-1">Powered by eBlackBookListings</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIPhotoshootsThankYouPage;
